<template>
  <div class="area-content">
    <div class="area-main">
      <div class="area-main-title">{{ info.name }}</div>
      <div class="area-main-bottom" v-if="info.content">
        <p
          class="keynote-main"
          @click="
            dialogVisible = true;
            title = info.name;
          "
        >
          {{ info.content }}
        </p>
        <div class="general-situation-img">
          <el-carousel
            v-if="info.imgUrl && info.imgUrl.length"
            height="160px"
            class="keynote-content-img"
          >
            <el-carousel-item v-for="(item, index) in info.imgUrl" :key="index">
              <img
                style="width: 100%; height: 100%; object-fit: cover"
                :src="imgUrl + item.filePath"
                alt=""
              />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="35%"
      :before-close="handleClose"
    >
      <div
        style="max-height: 600px; overflow: auto; letter-spacing: 4px"
        class="scrollbar-definition"
      >
        {{ info.content }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "areaMain",
  props: ["areaInfo"],
  data() {
    return {
      info: {},
      dialogVisible: false,
      title: "",
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
    };
  },
  watch: {
    areaInfo: {
      handler(newVal) {
        if (!!newVal) {
          this.info = newVal;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    changeTheme(val) {
      // console.log(val);
    },
  },
};
</script>

<style scoped>
.area-content {
  width: 60%;
  margin: 50px auto auto;
}
.area-main-title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  background-image: linear-gradient(90deg, #f58637, #fff7f2);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  letter-spacing: 1px;
}
.area-main-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.keynote-main {
  flex: 1;
  margin: 0;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  cursor: pointer;
}
.general-situation-img {
  width: calc(100% / 3);
  height: 160px;
  margin-left: 20px;
  /*background-image: linear-gradient(160deg, rgba(63,77,201,.8), rgba(102,180,213,.4));*/
  /* background-image: url("~@/assets/promotion/south.png");
  background-size: 100% 100%; */
}
::v-deep .el-dialog__body {
  padding: 10px 20px 30px;
}
</style>